import vue from 'vue'
import app from './app'
import store from "./stores"
import router from "./router"
import axios from "axios"
import vueAxios from "vue-axios"
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import vuelidate from "vuelidate"
import vueMoment from "vue-moment"
import VueTippy, {TippyComponent} from "vue-tippy";
import {Datetime} from 'vue-datetime'
import VueSimpleAlert from "vue-simple-alert";
import {ROUTE_AFTER_LOGIN_KEY} from "@/constants";
import {SET_SESSION_INFO, SET_VERSION} from "@/stores/application/mutations";
import "@/theme/theme.sass"
import 'vue-datetime/dist/vue-datetime.css'

vue.config.productionTip = false

axios.defaults.baseURL = "/API"
axios.defaults.headers.common['Pragma'] = 'no-cache'
axios.defaults.withCredentials = true

vue.use(vueAxios, axios)
vue.use(vuelidate)
vue.use(vueMoment)
vue.use(VueTippy);
vue.use(Datetime)
vue.use(VueSimpleAlert);
vue.component('datetime', Datetime);
vue.component('fa-icon', FontAwesomeIcon)
vue.component("tippy", TippyComponent);

vue.filter('truncate', function (text, stop, clamp) {
    if (!text)
        return text;

    return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '')
})

new vue({
    router: router,
    store,
    render: h => h(app),
    methods: {
        handleHashChangeOnInternetExplorer() {
            if ("-ms-scroll-limit" in document.documentElement.style && "-ms-ime-align" in document.documentElement.style) {
                window.addEventListener("hashchange", function () {
                    const newPath = window.location.hash.slice(1)

                    if (this.$route.path !== newPath)
                        this.$router.push(newPath)
                }, false)
            }
        },
        configureInterceptor() {
            axios.interceptors.response.use(response => {
                    return response;
                },
                error => {
                    if (error.response.status === 401) {
                        this.$store.commit(SET_SESSION_INFO, null);

                        if (this.$route.path !== "/login") {
                            sessionStorage.setItem(ROUTE_AFTER_LOGIN_KEY, this.$route.path);
                            this.$router.push("/login");
                        }
                    }

                    return Promise.reject(error);
                });
        },
        loadVersion() {
            this.$http.get("Application/Version").then(response => {
                this.$store.commit(SET_VERSION, response.data)
            });
        }
    },
    created() {
        this.handleHashChangeOnInternetExplorer()
        this.configureInterceptor()
        this.loadVersion()
    }
}).$mount('#app')